import React, { useEffect, useState } from "react";
import { Box, Center, Text, UnorderedList, ListItem } from "@chakra-ui/react";
import { Colors } from "../../../../static/static";
import "./lessonnominee.css";
import { fetchLessonNominee } from "../../../../services/homeContentService";
import lessonNomineeLandingPage from '../../../../data/lessonNomineeLandingPage.json'
import Loader from "../../../../components/common/Loader";

function LessonNominee({homepage=true}) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() =>{
    const getLessonNominee = async() =>{
      try{
        const response = await fetchLessonNominee();
        setData(response || [])
        setIsLoading(false);
      } catch(error){
        console.error('error while trying to get lesson nominee')
      }
    }
    if(homepage){
      getLessonNominee();
    } else{
      setData(lessonNomineeLandingPage);
      setIsLoading(false);
    }
  }, [homepage])

  if(isLoading){
    return <Loader />
  }


  return (
    <Center>
    <Box
      className="lesson-nominee-container"
      width="100%"
      height={{  md: homepage ? "78vh" : "70vh", lg: "60vh", xl: "50vh"}}
      bgColor={Colors.bgBlue} 
      bgImage={{base: "none", xl:"url('https://leadguitar.s3.eu-north-1.amazonaws.com/images/clientsbg.jpeg')"}}
      objectFit="cover"
      bgPosition={{ md:"center"}}
      bgRepeat="no-repeat"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
        <Box
          textAlign="center"
          dir="rtl"
          bg={Colors.bgText}
          width={{ base: "90%", md: "55%" }}
          padding={6}
        >
          <Text fontSize={{base: '1.2rem',md:"4.5vh"}} color={Colors.heading} mb={4} fontWeight={600}>
            {data.mainTitle}
          </Text>
          <Text fontSize={{base: '1.1rem',md:"2.5vh"}} mb={2}>
            {data.fitsToTitle}
          </Text>
          <UnorderedList textAlign="right" mb={4}>
            {data.fitsTo.map((item, index) => (
              <ListItem key={index} fontSize={{base: '0.8rem',md:"2vh"}}>
                {item}
              </ListItem>
            ))}
          </UnorderedList>
          <Text fontSize={{base: '1.1rem',md:"2.5vh"}} mb={2}>
            {data.notFitsToTitle}
          </Text>
          <UnorderedList textAlign="right" mb={4}>
            {data.notFitsTo.map((item, index) => (
              <ListItem key={index} fontSize={{base: '0.8rem',md:"2vh"}}>
                {item}
              </ListItem>
            ))}
          </UnorderedList>
        </Box>
      </Box>
    </Center>
  );
}

export default LessonNominee;
